module.exports = require('./helpers/bundle-url').getBundleURL('1i6XA') + "logo.c51670a8.svg";